webpackJsonp([243122681061137],{

/***/ 789:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"list_grid__item":"src-components-ArticleItem----ArticleItem-module---list_grid__item---1RuCu","list_grid__category":"src-components-ArticleItem----ArticleItem-module---list_grid__category---1e-SF","list_grid__info":"src-components-ArticleItem----ArticleItem-module---list_grid__info---1wrg3","date":"src-components-ArticleItem----ArticleItem-module---date---2jU6z","show_more":"src-components-ArticleItem----ArticleItem-module---show_more---385kI"};

/***/ }),

/***/ 651:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _helpers = __webpack_require__(43);
	
	var _ArticleItemModule = __webpack_require__(789);
	
	var _ArticleItemModule2 = _interopRequireDefault(_ArticleItemModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ArticleItem = function (_React$Component) {
		_inherits(ArticleItem, _React$Component);
	
		function ArticleItem(props) {
			_classCallCheck(this, ArticleItem);
	
			var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
			_this.handleTruncate = function () {
				var showAll = _this.state.showAll;
	
	
				_this.setState({ showAll: !showAll });
			};
	
			_this.state = {
				showAll: false
			};
			return _this;
		}
	
		ArticleItem.prototype.render = function render() {
			var _this2 = this;
	
			var showAll = this.state.showAll;
			var props = this.props;
	
	
			return _react2.default.createElement(
				"div",
				{ className: _ArticleItemModule2.default.list_grid__item },
				props.cat_url ? _react2.default.createElement(_gatsbyLink2.default, {
					to: props.cat_url,
					className: _ArticleItemModule2.default.list_grid__category
				}) : _react2.default.createElement(
					"span",
					{ className: _ArticleItemModule2.default.list_grid__category },
					props.category
				),
				_react2.default.createElement(
					"h5",
					null,
					_react2.default.createElement(
						"a",
						{ href: props.url, target: "_blank", className: "list_props_grid__link" },
						props.title
					)
				),
				_react2.default.createElement(
					"span",
					{ className: _ArticleItemModule2.default.list_grid__excerpt },
					props.excerpt && (!showAll ? (0, _helpers.truncate)(props.excerpt, 120, true) : props.excerpt),
					" ",
					props.excerpt && props.excerpt.length > 120 && _react2.default.createElement(
						"button",
						{
							onClick: function onClick() {
								return _this2.handleTruncate();
							},
							className: _ArticleItemModule2.default.show_more
						},
						!showAll ? "show more ▾" : "« show less"
					)
				),
				_react2.default.createElement(
					"span",
					{ className: _ArticleItemModule2.default.list_grid__info },
					props.pub_details && _react2.default.createElement(
						"span",
						{ className: _ArticleItemModule2.default.date },
						_react2.default.createElement(
							"span",
							{ style: { fontWeight: "bold" } },
							props.pub_details
						),
						", ",
						props.published_date
					)
				)
			);
		};
	
		return ArticleItem;
	}(_react2.default.Component);
	
	exports.default = ArticleItem;
	module.exports = exports["default"];

/***/ }),

/***/ 682:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Jumbotron = __webpack_require__(17);
	
	var _Jumbotron2 = _interopRequireDefault(_Jumbotron);
	
	var _ArticleItem = __webpack_require__(651);
	
	var _ArticleItem2 = _interopRequireDefault(_ArticleItem);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _subNav = __webpack_require__(73);
	
	var _subNav2 = _interopRequireDefault(_subNav);
	
	var _SectionTitle = __webpack_require__(53);
	
	var _SectionTitle2 = _interopRequireDefault(_SectionTitle);
	
	var _PageWrapper = __webpack_require__(21);
	
	var _PageWrapper2 = _interopRequireDefault(_PageWrapper);
	
	var _reactHelmet = __webpack_require__(15);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var renderPubs = function renderPubs() {
		var pubs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
		return pubs.map(function (_ref, i) {
			var node = _ref.node;
	
			return _react2.default.createElement(
				"div",
				{
					key: "pub-" + (i + 1),
					className: "col-12 col-sm-6 article_list_item"
				},
				_react2.default.createElement(_ArticleItem2.default, {
					category: "Publication",
					cat_url: "/publications",
					title: node.publicationTitle.publicationTitle,
					url: node.url,
					excerpt: node.authors.join(", "),
					pub_details: node.journal,
					published_date: node.publicationDate
				})
			);
		});
	};
	
	var Publications = function (_React$Component) {
		_inherits(Publications, _React$Component);
	
		function Publications() {
			var _temp, _this, _ret;
	
			_classCallCheck(this, Publications);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleSelect = function (year) {
				var locale = _this.props.data.contentfulPublicationsPage.node_locale;
				(0, _gatsbyLink.navigateTo)({
					pathname: "/" + locale + "/publications/" + year
				});
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		Publications.prototype.render = function render() {
			var _this2 = this;
	
			var _props = this.props,
			    transition = _props.transition,
			    pathContext = _props.pathContext,
			    data = _props.data;
			var allYears = pathContext.allYears,
			    year = pathContext.year;
	
			var pageSettings = data.contentfulPublicationsPage;
			var publicationsList = data.allContentfulPublicationLink.edges;
	
			var processedYears = allYears.map(function (item) {
				return {
					label: item,
					name: item,
					href: "/" + pageSettings.node_locale + "/publications/" + item
				};
			});
	
			return _react2.default.createElement(
				_PageWrapper2.default,
				{
					locale: pageSettings.node_locale,
					location: this.props.location,
					data: data.layout.edges[0].node
				},
				_react2.default.createElement(
					"main",
					{ role: "main", style: transition && transition.style },
					_react2.default.createElement(_reactHelmet2.default, { title: pageSettings.pageTitle + " | " + year + " | Mahidol Vivax Research Unit" }),
					_react2.default.createElement(
						_Jumbotron2.default,
						{
							type: "jumbotron_b",
							bottomLine: false,
							className: "mb-0",
							textAlign: "text-center",
							contentAlign: "justify-content-md-center"
						},
						_react2.default.createElement(
							"h1",
							null,
							pageSettings.pageTitle
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "container d-none d-xl-block" },
						_react2.default.createElement(
							"div",
							{ className: "row justify-content-center" },
							_react2.default.createElement(
								"div",
								{ className: "col-lg-12" },
								_react2.default.createElement(_subNav2.default, {
									navList: processedYears,
									active: year,
									handleClick: function handleClick() {}
								})
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "container mt-3 mt-lg-0" },
						_react2.default.createElement(_SectionTitle2.default, { type: "b", title: year }),
						_react2.default.createElement(
							"div",
							{ className: "row justify-content-center" },
							_react2.default.createElement(
								"div",
								{ className: "col-12 col-sm-6 col-md-4 d-xl-none" },
								_react2.default.createElement(
									"div",
									{ className: "form-group" },
									_react2.default.createElement(
										"select",
										{
											className: "form-control text-center select-style",
											id: "exampleFormControlSelect1",
											placeholder: "Readonly input here\u2026",
											onChange: function onChange(e) {
												return _this2.handleSelect(e.target.value);
											}
										},
										_react2.default.createElement(
											"option",
											{
												className: "text-center",
												value: "",
												disabled: true,
												selected: true,
												hidden: true
											},
											"Choose different year..."
										),
										allYears.map(function (item) {
											return _react2.default.createElement(
												"option",
												{
													disabled: item === year,
													selected: false,
													key: item
												},
												item
											);
										})
									)
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "container py-5" },
						_react2.default.createElement(
							"div",
							{ className: "row justify-content-start mb-5" },
							publicationsList.length > 0 ? renderPubs(publicationsList) : _react2.default.createElement(
								"div",
								{ className: "col-12 text-center my-5\t" },
								_react2.default.createElement(
									"h4",
									null,
									"Oops! Couldn't find any publications from this year"
								)
							)
						),
						_react2.default.createElement(
							"div",
							{ className: "row" },
							_react2.default.createElement(
								"div",
								{ className: "col-6 text-left" },
								allYears.indexOf(year) > 0 && _react2.default.createElement(
									_gatsbyLink2.default,
									{ className: "h5", to: "/" + pageSettings.node_locale + "/publications/" + allYears[allYears.indexOf(year) - 1] },
									"\xAB ",
									allYears[allYears.indexOf(year) - 1]
								)
							),
							_react2.default.createElement(
								"div",
								{ className: "col-6 text-right" },
								allYears.indexOf(year) < allYears.length - 1 && _react2.default.createElement(
									_gatsbyLink2.default,
									{ className: "h5", to: "/" + pageSettings.node_locale + "/publications/" + allYears[allYears.indexOf(year) + 1] },
									allYears[allYears.indexOf(year) + 1],
									" \xBB"
								)
							)
						)
					)
				)
			);
		};
	
		return Publications;
	}(_react2.default.Component);
	
	exports.default = Publications;
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-publications-template-js-0bf27599449b77215ec4.js